<template>
    <div class="StepHead">
        <div class="Steps">
            <div class="StepsItem">2. 专业信息</div>
        </div>
        <div class="StepHeadTit" style="margin-bottom: 0">* 选择项目编号,查看主题</div>
        <div :class="TypeId==1 ? 'StepJiBen1' : 'StepJiBen'">
        </div>
        <div class="StepComm">
            <div class="TBox"></div>
            <div class="StepCommItem">
                <div class="StepCommHead">
                    <div class="MarTop">
                        <div class="SupervisorItem">
                            <div><span class="Icon">*</span>项目编号</div>
                            <el-select 
                                v-model="selectedThemeId" 
                                class="Wid120" 
                                size="medium" 
                                placeholder="请选择项目编号"
                                @change="changeTheme">
                                <el-option
                                    v-for="item in projectCodeList"
                                    :key="item.xmCode"
                                    :label="item.xmCode"
                                    :value="item.xmCode">
                                </el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="MarTop">
                        <div class="SupervisorItem"><span class="Icon">*</span>主题</div>
                        <div class="SupervisorItem">
                            <div class="StepJiBenRadio">
                                <el-radio-group v-model="selectedTypes">
                                    <el-radio 
                                        v-for="item in themeList" 
                                        :key="item.id" 
                                        :label="item.name">
                                        {{ item.name }}
                                    </el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>

                    <div class="MarTop">
                        <div class="SupervisorItem">
                            <div><span class="Icon">*</span>作品名称</div>
                            <el-input class="Wid120" size="medium" placeholder="请输入作品名称（25字以内）" v-model="name"></el-input>
                            <p class="shuoming">
                                特别说明:为确保作品在展示过程中便于识别，建议作品名称尽量避免与已有作品重复
                            </p>
                        </div>
                    </div>
                    
                    <div class="StepCommIpt MarTop">
                        <div class="StepCommIptTxt"><span class="Icon">*</span>作品创作时间</div>
                            <div class="StepCommIptVal">
                                <el-date-picker 
                                    type="date" 
                                    placeholder="选择日期" 
                                    v-model="selected" 
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    format="yyyy-MM-dd">
                                </el-date-picker>
                            </div>
                    </div>

                    <div class="StepCommIpt MarTop content-form-section">
                        <div class="StepCommIptTxt"><span class="Icon">*</span>内容形式（仅可提交一个附件文件）</div>
                        <div class="content-types-container">
                            <!-- 使用单选按钮组 -->
                            <el-radio-group v-model="selectedOption" class="content-type-radio-group">
                                <el-radio 
                                    v-for="item in workTypeOptions" 
                                    :key="item.value" 
                                    :label="item.value"
                                    class="content-type-radio">
                                    {{ item.label }}
                                </el-radio>
                            </el-radio-group>

                            <!-- 根据选中的内容形式显示对应的上传区域 -->
                            <div v-if="selectedOption" class="content-type-item">
                                <div class="content-type-header">
                                    <span class="content-type-label">{{ getSelectedTypeLabel }}</span>
                                    <el-upload 
                                        action="none" 
                                        size="small" 
                                        :show-file-list="false" 
                                        :http-request="(file) => UpFile(file, selectedOption)" 
                                        :before-upload="(file) => beforeUpload(file, selectedOption)">
                                        <el-button class="upload-btn" type="primary" size="mini">上传</el-button>
                                    </el-upload>
                                </div>

                                <!-- 上传进度条 -->
                                <div v-if="uploadedFiles[selectedOption] && uploadedFiles[selectedOption].status === 'uploading'" class="upload-progress-container">
                                    <div class="upload-file-info">
                                        <i class="el-icon-document"></i>
                                        <span>{{ uploadedFiles[selectedOption].name }}</span>
                                    </div>
                                    <el-progress 
                                        :percentage="uploadProgress[selectedOption] || 0" 
                                        :stroke-width="10"
                                        :show-text="true"
                                        :status="uploadProgress[selectedOption] === 100 ? 'success' : undefined">
                                    </el-progress>
                                </div>

                                <!-- 已上传文件预览 -->
                                <div v-if="uploadedFiles[selectedOption] && uploadedFiles[selectedOption].status === 'success'" class="uploaded-preview">
                                    <div class="thumbnail-item">
                                        <img 
                                            :src="getFileIcon(uploadedFiles[selectedOption])" 
                                            alt="" 
                                            class="thumbnail-img" 
                                            @click="() => OpenLock(uploadedFiles[selectedOption])">
                                        <span class="file-name">{{ uploadedFiles[selectedOption].name }}</span>
                                        <div class="file-actions">
                                            <el-button type="text" @click="() => OpenLock(uploadedFiles[selectedOption])">预览</el-button>
                                            <el-button type="text" @click="removeFile(selectedOption)">删除</el-button>
                                        </div>
                                    </div>
                                </div>

                                <!-- 上传要求 -->
                                <div class="requirement-container">
                                    <div class="requirement-text">{{ uploadRequirements[selectedOption] }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="StepCommIpt MarTop">
            <div class="StepCommIptTxt">备注</div>
            <div class="StepCommIptVal" style="width: auto; flex: 1;">
                <el-input type="textarea" v-model="des" placeholder="请输入备注信息" :rows="4"></el-input>
            </div>
        </div>
        
        <div class="StepBtns">
            <div class="StepBtn" @click="ToggleStep('prve')" :class="{StpepDisabled:ConfigDisabled}">上一步</div>
            <div class="StepBtn" @click="ToggleStep('next')" :class="{StpepDisabled:ConfigDisabled}">下一步</div>
        </div>
        <el-dialog
            title="提示" 
            :visible.sync="loginDialogVisible"
            width="30%" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :show-close="false">
            <span>请先登录后再进行操作</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="$router.push('/')">返回首页</el-button>
                <el-button type="primary" @click="goToLogin">去登录</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import Global from '@/common/Global.vue';  // 添加这行
import OSS from 'ali-oss';

export default {
    inject: ['worksInfo', 'isEdit'],
    data() {
        return {
            ID: "",
            user_group_id: [],
            TypeData: [],
            name:'',
            TiShiBlon: false,
            FormData: [],
            SeleId: "",
            SeleData: [],
            ConfigDisabled: false,
            selected: "",
            objList: {},
            selectedOption: '', // 改为字符串，因为是单选
            selectedThemeId: "", // 选中的主题编号
            selectedTypes: '', // 改为字符串，不再是数组
            FormData1: {},     // 添加这一行，用于存储项目主题数据
            options: [],
            uploadedFiles: {}, // 改为对象，用类型作为key
            loginDialogVisible: false, // 添加登录提示对话框的显示状态
            projectList: {},  // 添加项目列表数据
            projectCodeList: [], // 添加项目编号列表
            themeList: [], // 添加主题列表数据
            workTypeOptions: [], // 添加内容形式选项数组
            projectId: "", // 添加项目ID字段
            des: '', // 添加备注字段
            uploadRequirements: {
                '1': {
                    title: '科普文章',
                    accept: '.doc,.docx,.pdf',
                    maxSize: 10,
                    description: '支持 doc、docx、pdf 格式，大小不超过 10MB'
                },
                '2': {
                    title: '科普图画',
                    accept: '.jpg,.jpeg,.png',
                    maxSize: 5,
                    description: '支持 jpg、jpeg、png 格式，大小不超过 5MB'
                },
                '3': {
                    title: '科普短视频',
                    accept: '.mp4,.avi,.mov',
                    maxSize: 100,
                    description: '支持 mp4、avi、mov 格式，大小不超过 100MB'
                },
                '4': {
                    title: '科普讲座',
                    accept: '.mp4,.avi,.mov',
                    maxSize: 500,
                    description: '支持 mp4、avi、mov 格式，大小不超过 500MB'
                }
            },
            uploadProgress: {}, // 添加上传进度对象
            ossClient: null, // 添加OSS客户端对象
            ossConfig: null,  // 添加OSS配置对象
            pendingProjectSync: null // 待同步的项目编号/ID
        }
    },
    computed: {
        getSelectedTypeLabel() {
            const selectedType = this.workTypeOptions.find(item => item.value === this.selectedOption);
            return selectedType ? selectedType.label : '';
        }
    },
    props: {
        TypeId: [String, Number],
        id: {
            type: [String, Number],
            default: ''  // 添加默认值
        },
        PageDisabled: Boolean,
        initialData: {  // 添加新的 prop
            type: Object,
            default: () => null
        }
    },
    created() {
        this.$axios = axios;
        // 将 Global 挂载到 Vue 实例上
        this.$Global = Global;
        
        // 检测是否在微信浏览器中
        const isWechat = /MicroMessenger/i.test(navigator.userAgent);
        // 检测是否在移动设备上
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isWechat && isMobile) {
            console.log('检测到微信移动浏览器环境，启用特殊处理');
            
            // 监听页面可见性变化
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
            
            // 监听微信返回按钮
            if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.handlePopState);
            }
        }
    },
    mounted() {
        // 获取项目编号列表
        this.getProjectList();
        
        this.ID = this.id || '';
        this.ConfigDisabled = this.PageDisabled;

        // 检查是否为草稿模式
        const isDraft = localStorage.getItem('isDraft') === 'true';
        const draftId = this.$route.query.draftId;
        
        if (isDraft && draftId) {
            // 获取草稿数据
            const draftData = localStorage.getItem('draftData');
            if (draftData) {
                try {
                    const parsedDraftData = JSON.parse(draftData);
                    
                    // 设置草稿数据
                    this.selectedThemeId = parsedDraftData.projectCode || '';
                    this.projectId = parsedDraftData.projectId || '';
                    this.selectedTypes = parsedDraftData.projectCase || '';
                    this.name = parsedDraftData.worksName || '';
                    this.selected = parsedDraftData.workTime ? parsedDraftData.workTime.split('T')[0] : '';
                    this.selectedOption = parsedDraftData.worksType || '';
                    this.des = parsedDraftData.des || '';
                    
                    console.log('草稿模式数据加载:', {
                        selectedThemeId: this.selectedThemeId,
                        projectId: this.projectId,
                        selectedTypes: this.selectedTypes,
                        selectedOption: this.selectedOption
                    });
                    
                    // 初始化上传的文件信息
                    this.uploadedFiles = {};
                    
                    // 如果有文件信息，则添加到 uploadedFiles 中
                    if (parsedDraftData.workFile) {
                        this.uploadedFiles['1'] = {
                            name: '科普文章',
                            url: parsedDraftData.workFile,
                            status: 'success'
                        };
                    }
                    
                    if (parsedDraftData.workPicFile) {
                        this.uploadedFiles['2'] = {
                            name: '科普图画',
                            url: parsedDraftData.workPicFile,
                            status: 'success'
                        };
                    }
                    
                    if (parsedDraftData.workVedioFile) {
                        this.uploadedFiles['3'] = {
                            name: '科普短视频',
                            url: parsedDraftData.workVedioFile,
                            status: 'success'
                        };
                    }
                    
                    if (parsedDraftData.workJzFile) {
                        this.uploadedFiles['4'] = {
                            name: '科普讲座',
                            url: parsedDraftData.workJzFile,
                            status: 'success'
                        };
                    }
                    
                    // 立即加载主题和内容形式
                    if (this.projectId) {
                        // 先延迟一小段时间确保项目列表已加载
                        setTimeout(() => {
                            this.getThemesByProjectId(this.projectId);
                            this.getWorkTypeByProjectId(this.projectId);
                        }, 300);
                    } else if (this.selectedThemeId) {
                        // 如果没有projectId但有selectedThemeId，通过项目编号找到项目ID
                        setTimeout(() => {
                            // 等待项目列表加载完成
                            if (this.projectCodeList.length > 0) {
                                const selectedProject = this.projectCodeList.find(item => item.xmCode === this.selectedThemeId);
                                if (selectedProject) {
                                    this.projectId = selectedProject.id;
                                    this.getThemesByProjectId(selectedProject.id);
                                    this.getWorkTypeByProjectId(selectedProject.id);
                                }
                            } else {
                                // 项目列表尚未加载完成，进一步延迟
                                setTimeout(() => {
                                    const selectedProject = this.projectCodeList.find(item => item.xmCode === this.selectedThemeId);
                                    if (selectedProject) {
                                        this.projectId = selectedProject.id;
                                        this.getThemesByProjectId(selectedProject.id);
                                        this.getWorkTypeByProjectId(selectedProject.id);
                                    }
                                }, 1000);
                            }
                        }, 300);
                    }
                } catch (error) {
                    console.error('解析草稿数据出错:', error);
                }
            }
        }

        // 检查是否从成功提交页面返回或是新增模式
        const isFromSuccess = this.$route.query.fromSuccess === 'true';
        const isNewMode = !(this.isEdit && this.isEdit());
        
        // 如果是从成功提交返回或新增模式，不恢复缓存数据
        if (isFromSuccess) {
            console.log('检测到从提交成功页面返回，不恢复缓存数据');
            // 清除缓存
            localStorage.removeItem('specialtyInfoTemp');
            localStorage.removeItem('specialtyInfoData');
            return;
        }

        // 编辑模式处理 - 优先处理编辑模式
        if (this.isEdit && this.isEdit()) {
            const info = this.worksInfo && this.worksInfo();
            if (info) {
                console.log('编辑模式数据:', info);
                
                // 设置项目编号和ID
                this.selectedThemeId = info.projectCode || '';
                this.projectId = info.projectId || '';
                this.selectedTypes = info.projectCase || '';
                this.name = info.worksName || '';
                this.selected = info.workTime ? info.workTime.split('T')[0] : '';
                this.selectedOption = info.worksType || '';
                this.des = info.des || '';
                
                console.log('编辑模式初始化数据:', {
                    selectedThemeId: this.selectedThemeId,
                    projectId: this.projectId,
                    selectedTypes: this.selectedTypes,
                    selectedOption: this.selectedOption,
                    des: this.des
                });
                
                // 恢复已上传的文件
                if (info.workFile) {
                    this.uploadedFiles['1'] = { 
                        url: info.workFile,
                        name: '科普文章',
                        status: 'success'
                    };
                }
                if (info.workPicFile) {
                    this.uploadedFiles['2'] = { 
                        url: info.workPicFile,
                        name: '科普图画',
                        status: 'success'
                    };
                }
                if (info.workVedioFile) {
                    this.uploadedFiles['3'] = { 
                        url: info.workVedioFile,
                        name: '科普短视频',
                        status: 'success'
                    };
                }
                if (info.workJzFile) {
                    this.uploadedFiles['4'] = { 
                        url: info.workJzFile,
                        name: '科普讲座',
                        status: 'success'
                    };
                }
                
                // 获取对应的主题和内容形式列表
                if (info.projectId) {
                    this.getThemesByProjectId(info.projectId);
                    this.getWorkTypeByProjectId(info.projectId);
                }
            }
        } 
        // 非编辑模式 - 从localStorage恢复数据，只有通过正常导航（如点击上一步）才恢复
        else if (!isFromSuccess) {
            // 从临时缓存或正式缓存恢复数据
            const savedSpecialtyInfoTemp = localStorage.getItem('specialtyInfoTemp');
            const savedSpecialtyInfo = localStorage.getItem('specialtyInfoData');
            
            let dataToRestore = null;
            
            if (savedSpecialtyInfoTemp) {
                try {
                    dataToRestore = JSON.parse(savedSpecialtyInfoTemp);
                    console.log('从临时存储恢复数据:', dataToRestore);
                } catch (error) {
                    console.error('解析临时存储数据失败:', error);
                }
            } else if (savedSpecialtyInfo) {
                try {
                    dataToRestore = JSON.parse(savedSpecialtyInfo);
                    console.log('从正式存储恢复数据:', dataToRestore);
                } catch (error) {
                    console.error('解析正式存储数据失败:', error);
                }
            }
            
            if (dataToRestore) {
                // 恢复基本信息
                this.selectedThemeId = dataToRestore.selectedThemeId || dataToRestore.projectCode || '';
                this.projectId = dataToRestore.projectId || '';
                this.selectedTypes = dataToRestore.selectedTypes || dataToRestore.projectCase || '';
                this.name = dataToRestore.worksName || '';
                this.selected = dataToRestore.workTime || '';
                this.selectedOption = dataToRestore.worksType || '';
                this.des = dataToRestore.des || '';
                
                this.ensureProjectPair({
                    projectId: this.projectId,
                    projectCode: this.selectedThemeId
                });
                
                console.log('恢复的专业信息:', {
                    selectedThemeId: this.selectedThemeId,
                    projectId: this.projectId,
                    selectedTypes: this.selectedTypes,
                    selectedOption: this.selectedOption,
                    des: this.des
                });
                
                // 恢复已上传的文件
                if (dataToRestore.workFile) {
                    this.uploadedFiles['1'] = { 
                        url: dataToRestore.workFile,
                        name: '科普文章',
                        status: 'success'
                    };
                }
                if (dataToRestore.workPicFile) {
                    this.uploadedFiles['2'] = { 
                        url: dataToRestore.workPicFile,
                        name: '科普图画',
                        status: 'success'
                    };
                }
                if (dataToRestore.workVedioFile) {
                    this.uploadedFiles['3'] = { 
                        url: dataToRestore.workVedioFile,
                        name: '科普短视频',
                        status: 'success'
                    };
                }
                if (dataToRestore.workJzFile) {
                    this.uploadedFiles['4'] = { 
                        url: dataToRestore.workJzFile,
                        name: '科普讲座',
                        status: 'success'
                    };
                }
                
                // 延迟加载主题和内容形式，确保项目列表先加载完成
                setTimeout(() => {
                    if (this.projectId) {
                        console.log('延迟加载主题和内容形式，项目ID:', this.projectId);
                        this.getThemesByProjectId(this.projectId);
                        setTimeout(() => {
                            this.getWorkTypeByProjectId(this.projectId);
                            
                            // 确保主题被正确设置
                            setTimeout(() => {
                                if (this.themeList.length > 0 && !this.selectedTypes) {
                                    console.log('延迟设置主题，选择第一个可用主题');
                                    this.selectedTypes = this.themeList[0].name;
                                }
                            }, 300);
                        }, 200);
                    }
                }, 500);
            }
        }
        
        this.getWorkTypeList();
        this.checkLoginStatus();
    },
    methods: {
        ChangeData(val) {
            var blon = true;
            if (this.TypeId == 2) {
                if (val.length == 0) { blon = false; this.SeleData = [] }
                val = val.toString(val)
            }
            if (blon) { this.GetFormData(val) }
            this.selected = ''
            this.SeleData = []
        },
        supervisorAdd(item) {
            item.supervisor.push({
                name: "",
                mobile: "",
                code: "",
            })
        },
        supervisorDel(i, s) {
            i.supervisor.splice(s, 1)
        },
        ShowData(val) {
            this.SeleData = [];
            if (this.TypeId == 1) {
                this.FormData.forEach(item => {
                    if (item.id == val) {
                        this.SeleData.push(item)
                    }
                })
            } else {
                val.forEach(item => {
                    this.FormData.forEach(items => {
                        if (items.id == item) {
                            this.SeleData.push(items)
                        }
                    })
                })
            }
        },
        ToggleStep(s) {
            if (this.ConfigDisabled) return;
            
            // 检查是否有文件正在上传中
            const hasUploadingFile = Object.values(this.uploadedFiles).some(file => file.status === 'uploading');
            if (hasUploadingFile && s === 'next') {
                this.$message.warning('文件还在上传中，请稍等...');
                return;
            }
            // 表单验证 - 只在点击下一步时验证
            if (s === "next") {
                if (!this.selectedThemeId) {
                    this.$message.warning("请选择项目编号");
                    return;
                }
                if (!this.selectedTypes) {
                    this.$message.warning("请选择主题");
                    return;
                }
                if (!this.name) {
                    this.$message.warning("请输入作品名称");
                    return;
                }
                if (!this.selected) {
                    this.$message.warning("请选择作品创作时间");
                    return;
                }
                if (!this.selectedOption) {
                    this.$message.warning("请选择内容形式");
                    return;
                }
                if (!this.uploadedFiles[this.selectedOption]) {
                    this.$message.warning(`请上传${this.getSelectedTypeLabel}文件`);
                    return;
                }
                // 检查文件是否上传成功
                if (this.uploadedFiles[this.selectedOption].status !== 'success') {
                    if (this.uploadedFiles[this.selectedOption].status === 'uploading') {
                        this.$message.warning(`${this.getSelectedTypeLabel}还未上传完成，请稍等`);
                    } else if (this.uploadedFiles[this.selectedOption].status === 'error') {
                        this.$message.warning(`${this.getSelectedTypeLabel}上传失败，请重新上传`);
                    } else {
                        this.$message.warning(`${this.getSelectedTypeLabel}文件状态异常，请重新上传`);
                    }
                    return;
                }
            }

            const matchedProject = this.ensureProjectPair();
            // 如果未匹配到项目编号，保持当前选择继续提交，避免阻断流程
            if (!matchedProject) {
                console.warn('未在项目列表中找到匹配的项目编号，沿用当前选择继续提交');
            }

            // 构建当前页面数据
            const formData = {
                selectedThemeId: this.selectedThemeId, // 保存项目编号
                projectId: this.projectId,             // 保存项目ID
                projectCode: this.selectedThemeId,     // 兼容性字段
                projectCase: this.selectedTypes,       // 保存主题
                worksType: this.selectedOption,        // 保存内容形式
                worksName: this.name,                  // 保存作品名称
                workTime: this.selected,               // 保存创作时间
                des: this.des,                         // 保存备注信息
                
                // 添加这些字段确保数据兼容性
                selectedTypes: this.selectedTypes      // 另一个兼容性字段
            };
            
            // 添加所有类型的文件信息 - 使用完整URL
            if (this.uploadedFiles['1']) {
                formData.workFile = this.uploadedFiles['1'].url || '';
                // 确保使用https协议
                if (formData.workFile && formData.workFile.startsWith('http:')) {
                    formData.workFile = formData.workFile.replace('http:', 'https:');
                }
            }
            if (this.uploadedFiles['2']) {
                formData.workPicFile = this.uploadedFiles['2'].url || '';
                // 确保使用https协议
                if (formData.workPicFile && formData.workPicFile.startsWith('http:')) {
                    formData.workPicFile = formData.workPicFile.replace('http:', 'https:');
                }
            }
            if (this.uploadedFiles['3']) {
                formData.workVedioFile = this.uploadedFiles['3'].url || '';
                // 确保使用https协议
                if (formData.workVedioFile && formData.workVedioFile.startsWith('http:')) {
                    formData.workVedioFile = formData.workVedioFile.replace('http:', 'https:');
                }
            }
            if (this.uploadedFiles['4']) {
                formData.workJzFile = this.uploadedFiles['4'].url || '';
                // 确保使用https协议
                if (formData.workJzFile && formData.workJzFile.startsWith('http:')) {
                    formData.workJzFile = formData.workJzFile.replace('http:', 'https:');
                }
            }

            // 无论上一步还是下一步，都保存当前状态到临时存储
            localStorage.setItem('specialtyInfoTemp', JSON.stringify(formData));
            console.log('保存到临时存储:', formData);
            
            // 只有点击下一步时才保存到正式存储
            if (s === "next") {
                localStorage.setItem('specialtyInfoData', JSON.stringify(formData));
                console.log('保存到正式存储:', formData);
            }
            
            // 如果是点击上一步，需要确保基本信息页能够恢复数据
            if (s === "prve") {
                // 获取当前已存在的基本信息数据
                const basicInfoData = localStorage.getItem('basicInfoData');
                
                // 确保基本信息数据已存在，如果不存在则不进行任何操作
                if (basicInfoData) {
                    // 解析现有的基本信息数据
                    try {
                        const basicInfo = JSON.parse(basicInfoData);
                        
                        // 不做修改，只重新保存以更新时间戳，确保数据不会因为时间过期而丢失
                        localStorage.setItem('basicInfoData', JSON.stringify(basicInfo));
                        console.log('重新保存基本信息数据:', basicInfo);
                    } catch (error) {
                        console.error('解析基本信息数据失败:', error);
                    }
                } else {
                    console.warn('未找到基本信息数据，无法恢复');
                }
                
                // 在formData中添加fromPrevious标记
                formData.fromPrevious = true;
            }
            
            // 触发父组件事件
            this.$emit("PageBtn", s, formData);
        },
        OpenLock(file) {
            if (!file) return;
            
            // 检查是否在微信浏览器中
            const isWechat = /MicroMessenger/i.test(navigator.userAgent);
            // 检查是否在移动设备上
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            
            // 确保文件URL使用https协议
            if (file.url && file.url.startsWith('http:')) {
                file.url = file.url.replace('http:', 'https:');
            }
            
            // 如果是微信移动端，使用特殊处理以避免页面跳转
            if (isWechat && isMobile) {
                // 保存当前数据以防丢失
                this.saveCurrentData();
                
                // 使用预览图片的方式替代直接打开链接
                if (file.url && (file.url.match(/\.(jpg|jpeg|png|gif)$/i))) {
                    // 使用微信提供的图片预览API
                    if (window.WeixinJSBridge && window.WeixinJSBridge.invoke) {
                        window.WeixinJSBridge.invoke('imagePreview', {
                            current: file.url,
                            urls: [file.url]
                        });
                    } else {
                        // 创建临时图片预览元素
                        const previewContainer = document.createElement('div');
                        previewContainer.style.position = 'fixed';
                        previewContainer.style.top = '0';
                        previewContainer.style.left = '0';
                        previewContainer.style.width = '100%';
                        previewContainer.style.height = '100%';
                        previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
                        previewContainer.style.zIndex = '10000';
                        previewContainer.style.display = 'flex';
                        previewContainer.style.justifyContent = 'center';
                        previewContainer.style.alignItems = 'center';
                        
                        const img = document.createElement('img');
                        img.src = file.url;
                        img.style.maxWidth = '100%';
                        img.style.maxHeight = '90%';
                        
                        previewContainer.appendChild(img);
                        document.body.appendChild(previewContainer);
                        
                        // 点击关闭预览
                        previewContainer.addEventListener('click', () => {
                            document.body.removeChild(previewContainer);
                        });
                    }
                    return;
                }
                
                // 对于非图片文件，显示提示消息
                this.$message.info('微信浏览器限制了直接打开文件，请使用其他浏览器查看该文件');
                return;
            }
            
            // 为文件生成带签名的URL
            let fileUrl = file.url;
            
            // 确保使用https协议
            if (fileUrl && fileUrl.startsWith('http:')) {
                fileUrl = fileUrl.replace('http:', 'https:');
            }
            
            // 如果是OSS的URL，且不包含签名
            if (fileUrl && fileUrl.includes('aliyuncs.com') && !fileUrl.includes('Signature=')) {
                // 获取上传类型
                let fileType = null;
                // 遍历uploadedFiles找到对应的类型
                for (const type in this.uploadedFiles) {
                    if (this.uploadedFiles[type] && this.uploadedFiles[type].url === fileUrl) {
                        fileType = type;
                        break;
                    }
                }
                
                if (fileType) {
                    // 生成签名URL
                    const signedUrl = this.getSignedPreviewUrl(fileType);
                    if (signedUrl) {
                        fileUrl = signedUrl;
                        console.log('使用签名URL预览:', fileUrl);
                    }
                }
            }
            
            // 获取文件扩展名
            const fileExtension = file.name ? file.name.split('.').pop().toLowerCase() : '';
            
            // 根据文件类型选择预览方式
            if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)) {
                // 图片预览 - 使用新窗口直接打开
                window.open(fileUrl, '_blank');
            } else if (['pdf'].includes(fileExtension)) {
                // PDF预览 - 使用内嵌预览
                const viewerUrl = `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(fileUrl)}`;
                window.open(viewerUrl, '_blank');
            } else if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(fileExtension)) {
                // Office文档 - 使用Office Online或Google Docs预览
                // 尝试使用Office Online
                const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl)}`;
                window.open(officeViewerUrl, '_blank');
            } else if (['mp4', 'webm', 'ogg'].includes(fileExtension)) {
                // 视频文件 - 在新页面创建video元素
                const videoHtml = `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>视频预览</title>
                        <style>
                            body { margin: 0; background: #000; height: 100vh; display: flex; align-items: center; justify-content: center; }
                            video { max-width: 100%; max-height: 100%; }
                        </style>
                    </head>
                    <body>
                        <video controls autoplay>
                            <source src="${fileUrl}" type="video/${fileExtension}">
                            您的浏览器不支持视频播放
                        </video>
                    </body>
                    </html>
                `;
                const videoWindow = window.open('', '_blank');
                if (videoWindow) {
                    videoWindow.document.write(videoHtml);
                    videoWindow.document.close();
                } else {
                    // 如果弹出窗口被阻止，则使用普通方式打开
                    window.open(fileUrl, '_blank');
                }
            } else {
                // 其他文件类型，尝试在新窗口直接打开
                window.open(fileUrl, '_blank');
            }
            
            return;
        },
        CloseImg(type, i, is, s) {
            if (type == 'fu') {
                this.SeleData[i].file.splice(is, 1)
            } else {
                this.SeleData[i].children[is].file.splice(s, 1)
            }
        },
        CloseTempImg(type, i, is, s) {
            if (type == 'fu') {
                this.SeleData[i].templatefile.splice(is, 1)
            } else {
                this.SeleData[i].children[is].templatefile.splice(s, 1)
            }
        },
        beforeUpload(file, type) {
            // 首先保存当前数据，防止上传过程中数据丢失
            this.saveCurrentData();
            
            // 如果已有该类型的文件，释放之前的 URL
            if (this.uploadedFiles[type] && this.uploadedFiles[type].previewUrl) {
                URL.revokeObjectURL(this.uploadedFiles[type].previewUrl);
            }

            // 根据不同类型的作品，获取文件格式和大小限制
            const fileName = file.name.toLowerCase();
            const fileSize = file.size / 1024 / 1024; // 转换为MB
            
            // 科普文章: 只能上传Word文档
            if (type === '1') {
                const isWord = fileName.endsWith('.doc') || fileName.endsWith('.docx');
                if (!isWord) {
                    this.$message.error('科普文章只能上传Word文档(.doc/.docx)');
                    return false;
                }
            } 
            // 科普图画: 高分辨率图片
            else if (type === '2') {
                const isImage = /\.(jpg|jpeg|png|gif|bmp)$/.test(fileName);
                if (!isImage) {
                    this.$message.error('科普图画只能上传图片文件(.jpg/.jpeg/.png/.gif/.bmp)');
                    return false;
                }
            } 
            // 科普视频: 只能上传MOV或MP4
            else if (type === '3') {
                const isVideo = fileName.endsWith('.mov') || fileName.endsWith('.mp4');
                if (!isVideo) {
                    this.$message.error('科普短视频只能上传MOV或MP4格式视频');
                    return false;
                }
            } 
            // 科普讲座: 只能上传MOV或MP4
            else if (type === '4') {
                const isVideo = fileName.endsWith('.mov') || fileName.endsWith('.mp4');
                if (!isVideo) {
                    this.$message.error('科普讲座只能上传MOV或MP4格式视频');
                    return false;
                }
            }

            // 生成本地预览 URL
            const previewUrl = URL.createObjectURL(file);
            this.$set(this.uploadedFiles, type, {
                name: file.name,
                type: file.type,
                previewUrl: previewUrl,
                url: '',
                status: 'uploading'
            });
            
            return true;
        },

        UpFile({ file }, type) {
            // 首先保存当前数据，防止上传过程中数据丢失
            this.saveCurrentData();
            
            // 设置初始状态为上传中
            if (!this.uploadedFiles[type]) {
                this.$set(this.uploadedFiles, type, {
                    name: file.name,
                    type: file.type,
                    previewUrl: URL.createObjectURL(file),
                    url: '',
                    status: 'uploading'
                });
            } else {
                this.uploadedFiles[type].status = 'uploading';
            }
            
            // 重置进度为0
            this.$set(this.uploadProgress, type, 0);
            
            // 直接使用硬编码的OSS配置
            const ossConfig = {
                region: 'oss-cn-beijing',
                accessKeyId: 'LTAI5tBphGbo6FUYpUPLznut',
                accessKeySecret: 'hKS8r96SgqDPVekeMZRPIWVLnj5DzU',
                bucket: 'bxxcx-bahimorgcn',
                endpoint: 'oss-cn-beijing.aliyuncs.com'
            };
            
            try {
                // 创建OSS客户端
                const client = new OSS(ossConfig);
                
                // 生成唯一的文件名
                const timestamp = new Date().getTime();
                const randomStr = Math.random().toString(36).substr(2, 6);
                const extension = file.name.substr(file.name.lastIndexOf('.'));
                const objectName = `uploads/${type}/${timestamp}_${randomStr}${extension}`;
                
                // 设置OSS上传选项
                const options = {
                    progress: (p) => {
                        // 更新上传进度，最大显示到95%
                        const percent = Math.min(Math.floor(p * 95), 95);
                        this.$set(this.uploadProgress, type, percent);
                    },
                    // 设置单个分片上传超时为10分钟
                    timeout: 600000, // 10分钟 = 600秒 = 600000毫秒
                    // 设置正确的HTTP头
                    headers: {
                        // 设置Content-Type为文件的MIME类型
                        'Content-Type': this.getContentType(file.name) || 'application/octet-stream',
                        // 设置Content-Disposition为inline，确保文件内联显示而不是下载
                        'Content-Disposition': 'inline'
                    }
                };
                
                // 使用OSS SDK上传文件
                client.multipartUpload(objectName, file, options).then(result => {
                    // 上传已完成，设置进度为100%
                    this.$set(this.uploadProgress, type, 100);
                    
                    // 设置短暂延迟，让用户看到100%的进度
                    setTimeout(() => {
                        // 获取不带参数的纯URL
                        let fileUrl = result.res.requestUrls[0].split('?')[0];
                        
                        // 不再生成带签名的URL，直接使用纯URL
                        console.log('使用不带签名的原始URL:', fileUrl);
                        
                        // 使用返回的完整URL
                        const fileInfo = {
                            name: file.name,
                            url: fileUrl,
                            previewUrl: fileUrl,
                            status: 'success'
                        };
                        
                        // 更新uploadedFiles对象
                        this.$set(this.uploadedFiles, type, fileInfo);
                        
                        // 提取路径，确保只保存相对路径
                        const pathOnly = this.extractPathFromUrl(fileUrl);
                        console.log(`文件上传成功，提取后的路径: ${pathOnly}`);
                        
                        // 更新uploadedFiles对象，确保url属性只存储路径部分
                        this.uploadedFiles[type].pathOnly = pathOnly;
                        
                        // 上传成功后再次保存当前数据
                        this.saveCurrentData();
                        
                        this.$message.success('上传成功');
                    }, 500); // 延迟500毫秒，让进度条显示完成状态
                }).catch(err => {
                    // 设置进度为0表示失败
                    this.$set(this.uploadProgress, type, 0);
                    
                    console.error('上传失败:', err);
                    this.$message.error('上传失败: ' + (err.message || '未知错误'));
                    
                    if (this.uploadedFiles[type] && this.uploadedFiles[type].previewUrl) {
                        URL.revokeObjectURL(this.uploadedFiles[type].previewUrl);
                    }
                    
                    // 更新状态为失败
                    if (this.uploadedFiles[type]) {
                        this.uploadedFiles[type].status = 'error';
                    }
                    
                    // 尝试使用传统上传方式
                    this.useTraditionalUpload(file, type);
                });
            } catch (error) {
                console.error('OSS客户端创建失败:', error);
                // 降级到传统上传方式
                this.useTraditionalUpload(file, type);
            }
        },

        // 获取STS临时令牌
        getSTSToken() {
            return new Promise((resolve, reject) => {
                // 首先尝试从缓存获取STS令牌
                const cachedToken = localStorage.getItem('stsToken');
                const cachedTokenExpire = localStorage.getItem('stsTokenExpire');
                
                // 检查缓存的令牌是否可用
                if (cachedToken && cachedTokenExpire) {
                    const tokenData = JSON.parse(cachedToken);
                    const expireTime = parseInt(cachedTokenExpire);
                    
                    // 如果令牌有效且未过期（预留5分钟缓冲）
                    if (expireTime && expireTime > Date.now() + 5 * 60 * 1000) {
                        return resolve(tokenData);
                    }
                }
                
                // 缓存无效或已过期，从服务器获取新令牌
                this.$axios.get('/common/getStsToken').then(res => {
                    if (res.data.code === 200 && res.data.data) {
                        // 保存令牌到本地缓存
                        localStorage.setItem('stsToken', JSON.stringify(res.data.data));
                        
                        // 计算过期时间（减去10分钟作为安全边界）
                        const expireTime = Date.now() + res.data.data.ExpirationSeconds * 1000 - 10 * 60 * 1000;
                        localStorage.setItem('stsTokenExpire', expireTime.toString());
                        
                        resolve(res.data.data);
                    } else {
                        console.error('获取STS令牌失败:', res.data.msg);
                        reject(new Error(res.data.msg || '获取STS令牌失败'));
                    }
                }).catch(err => {
                    console.error('获取STS令牌请求失败:', err);
                    reject(err);
                });
            });
        },

        // 原始上传方式，用于OSS直传失败的情况
        useTraditionalUpload(file, type) {
            console.log('使用传统上传方式:', file.name);
            const fd = new FormData();
            fd.append('file', file);
            
            // 记录开始上传的时间
            const startTime = performance.now();
            
            // 标记为正在上传
            if (this.uploadedFiles[type]) {
                this.uploadedFiles[type].name = file.name;
                this.uploadedFiles[type].status = 'uploading';
            } else {
                this.$set(this.uploadedFiles, type, {
                    name: file.name,
                    status: 'uploading'
                });
            }
            
            // 使用axios发送请求
            this.$axios.post('/common/uploadAliOss', fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: progressEvent => {
                    if (progressEvent.lengthComputable) {
                        // 计算上传进度
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                    );
                    this.$set(this.uploadProgress, type, percentCompleted);
                    }
                }
            })
            .then(response => {
                // 请求完成后，设置进度为100%
                    this.$set(this.uploadProgress, type, 100);
                    
                // 计算上传耗时
                const endTime = performance.now();
                const duration = ((endTime - startTime) / 1000).toFixed(2);
                console.log(`文件上传完成，耗时: ${duration}秒`);
                
                if (response.data.code === 200) {
                    // 确保URL使用https协议
                    let fileUrl = response.data.data;
                    if (fileUrl && fileUrl.startsWith('http:')) {
                        fileUrl = fileUrl.replace('http:', 'https:');
                    }
                    
                    // 构造文件信息对象
                        const fileInfo = {
                        name: file.name,
                        url: fileUrl,
                        status: 'success',
                        size: file.size,
                        type: file.type
                    };
                        
                        // 更新uploadedFiles对象
                        this.$set(this.uploadedFiles, type, fileInfo);
                        
                    // 提示上传成功
                    this.$message.success('文件上传成功');
                } else {
                    // 上传失败，重置进度
                    this.$set(this.uploadProgress, type, 0);
                    
                    // 清理预览URL
                    if (this.uploadedFiles[type] && this.uploadedFiles[type].previewUrl) {
                        URL.revokeObjectURL(this.uploadedFiles[type].previewUrl);
                    }
                    
                    // 标记为上传失败
                    if (this.uploadedFiles[type]) {
                        this.uploadedFiles[type].status = 'error';
                    }
                    
                    // 提示上传失败
                    this.$message.error(response.data.msg || '文件上传失败');
                }
            })
            .catch(error => {
                // 请求出错，重置进度
                this.$set(this.uploadProgress, type, 0);
                
                // 清理预览URL
                if (this.uploadedFiles[type] && this.uploadedFiles[type].previewUrl) {
                    URL.revokeObjectURL(this.uploadedFiles[type].previewUrl);
                }
                
                // 标记为上传失败
                if (this.uploadedFiles[type]) {
                    this.uploadedFiles[type].status = 'error';
                }
                
                // 提示上传失败
                this.$message.error('文件上传失败: ' + (error.message || error));
                console.error('上传失败:', error);
            });
        },
        getImageUrl(file) {
            if (!file) return '';
            
            // 如果有本地预览URL，优先使用本地预览
            if (file.previewUrl && file.previewUrl.startsWith('blob:')) {
                return file.previewUrl;
            }
            
            // 否则使用服务器URL，添加服务器前缀
            if (file.url) {
                // 避免重复添加前缀
                if (file.url.startsWith('http')) {
                    return file.url;
                } else {
                    return this.$Global.CommImgHttp + file.url;
                }
            }
            
            return '';
        },

        // 组件销毁时释放本地 URL
        beforeDestroy() {
            // 释放资源，避免内存泄漏
            Object.values(this.uploadedFiles).forEach(file => {
                if (file && file.previewUrl && file.previewUrl.startsWith('blob:')) {
                    URL.revokeObjectURL(file.previewUrl);
                }
            });
            
            // 检查是否从提交成功页面返回
            const isFromSuccess = this.$route.query.fromSuccess === 'true';
            
            // 如果是从提交成功页面返回，清除所有缓存
            if (isFromSuccess) {
                localStorage.removeItem('specialtyInfoTemp');
                localStorage.removeItem('specialtyInfoData');
                localStorage.removeItem('basicInfoData');
            }
            
            // 移除事件监听器
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
            window.removeEventListener('popstate', this.handlePopState);
        },
        // 为文件生成带签名的URL
        getSignedFileUrl(type) {
            // 确保有上传文件且文件有URL
            if (!this.uploadedFiles[type] || !this.uploadedFiles[type].url) {
                return '';
            }
            
            try {
                // 不再生成签名URL，直接返回原始URL
                console.log('使用原始URL，不生成签名:', this.uploadedFiles[type].url);
                return this.uploadedFiles[type].url;
            } catch (error) {
                console.error('获取URL失败:', error);
                return this.uploadedFiles[type].url;
            }
        },
        ChangeVal(item) {
            if (item.standard_value != "") {
                if (parseFloat(item.val) < item.standard_value) {
                    this.$message.error("输入值不能小于标准值" + item.standard_value);
                    item.val = "";
                }
            }
        },
        GoPage(url) {
            this.$router.push({
                path: url
            });
        },
        GoBack() {
            this.$router.push({
                path: '/UserInfo',
                query: {
                    id: 3
                }
            })
        },
        changeTheme(value) {
            console.log('选择的项目编号:', value);
            
            // 找到选中的项目信息
            const selectedProject = this.projectCodeList.find(item => item.xmCode === value);
            if (selectedProject) {
                this.projectId = selectedProject.id; // 保存项目ID
                console.log('获取到项目ID:', this.projectId);
                this.ensureProjectPair({
                    projectId: selectedProject.id,
                    projectCode: value
                });
                
                // 异步获取主题和内容形式
                this.$nextTick(() => {
                    // 获取主题
                    this.getThemesByProjectId(selectedProject.id);
                    
                    // 稍微延迟获取内容形式，确保主题已加载
                    setTimeout(() => {
                        this.getWorkTypeByProjectId(selectedProject.id);
                    }, 200);
                });
                
                // 清空之前选择的主题和内容形式（除非在编辑模式且是同一个项目）
                const isEditingSameProject = this.isEdit && this.isEdit() && 
                                            this.worksInfo && this.worksInfo() && 
                                            this.worksInfo().projectId === selectedProject.id;
                
                if (!isEditingSameProject) {
                    this.selectedTypes = '';
                    this.selectedOption = '';
                }

                this.updateCachedProjectSelection();
            } else {
                this.$message.warning('未找到该项目编号对应的主题');
                this.themeList = [];
                this.selectedTypes = '';
                this.projectId = ''; // 清空项目ID
            }
        },
        updateSelectedTypes() {
            // 当注册类型选择变化时，更新 SeleData（可根据需求调整逻辑）
            this.ShowData(this.selectedThemeId); // 根据主题编号重新加载数据
        },
        getWorkTypeList() {
            this.$get('/api/v1/works/getWorkType').then(res => {
                if (res.data.code === 200) {
                    // 转换数据格式
                    this.options = res.data.data.filter(item => item.status === '0').map(item => ({
                        value: item.dictValue,
                        label: item.dictLabel
                    }));

                    // 同时更新 uploadRequirements 对象，使用 dictValue 作为 key
                    const newUploadRequirements = {};
                    res.data.data.filter(item => item.status === '0').forEach(item => {
                        // 根据不同的内容形式设置对应的上传要求
                        switch(item.dictLabel) {
                            case '科普文章':
                                newUploadRequirements[item.dictValue] = `需以文字形式上报;
整体结构应清晰明确，涵盖标题、引言、正文与结论等部分;
若有引用数据或研究务必注明出处;
文件格式须为 Word，其中标题采用黑体小三号字体，正文使用宋体小四号字体，行间距设置为 1.5 倍，标点符号使用规范，字数需控制在5000字以内。`;
                                break;
                            case '科普图画':
                                newUploadRequirements[item.dictValue] = `需为原创，满足文字和图片等基本元素的合理组织和布局，色彩搭配和谐，符合大众审美需求;
以某个知识点展开讲解，信息传递要直观完整。形式可为一图读懂、插图、漫画等。分辨率不低于300dpi。`;
                                break;
                            case '科普短视频':
                                newUploadRequirements[item.dictValue] = `时长:1-5分钟，格式:MOV 或 MP4，分辨率：不低于 1080P;
内容方面：精益求精，提炼干货，符合用户碎片化的阅读习惯，节约观众的时间成本;
讲解人妆造需得体，使用普通话脱稿表达且无念稿痕迹，声音清晰，语言准确规范;
视频画面简洁、结构合理。若进行剪辑制作，则视听元素需恰当运用，音效不刺耳，背景音乐音量合理不干扰人声;
若附字幕，字体大小适中，避免错别字；需保持作品完整。`;
                                break;
                            case '科普讲座':
                                newUploadRequirements[item.dictValue] = `时长:20-50分钟，格式:MOV 或 MP4，分辨率:不低于 1080P，形式:线上/线下科普讲座视频;
内容方面：结构逻辑清晰，深入浅出讲解内容，避免过多堆砌专业术语;
主讲人着装得体，表情自然，使用普通话讲解，语速适中，声音清晰，可配合 PPT 或其他视觉辅助材料进行讲解;
视频画面简洁、结构合理。若进行剪辑制作，则视听元素需恰当运用，音效不刺耳，背景音乐音量合理不干扰人声;
若附字幕，字体大小适中，避免错别字；需保持作品完整。`;
                                break;
                        }
                    });
                    this.uploadRequirements = newUploadRequirements;
                } else {
                    this.$message.error(res.data.msg || '获取内容形式列表失败');
                }
            }).catch(err => {
                console.error('获取内容形式列表失败:', err);
                this.$message.error('获取内容形式列表失败');
            });
        },
        checkLoginStatus() {
            // 从localStorage或Vuex中获取token，具体实现根据您的登录机制调整
            const token = localStorage.getItem('token');
            if (!token) {
                this.loginDialogVisible = true;
            }
        },
        goToLogin() {
            this.loginDialogVisible = false;
            // 保存当前页面路径，以便登录后返回
            localStorage.setItem('redirectPath', this.$route.fullPath);
            this.$router.push('/');
        },
        getProjectList() {
            this.$get('/api/v1/works/projectlist').then(res => {
                if (res.data.code === 200) {
                    this.projectCodeList = res.data.data; // 存储项目编号列表
                    this.projectList = {}; // 构建项目编号和主题的映射
                    res.data.data.forEach(item => {
                        this.projectList[item.xmCode] = item.themes || []; // 假设主题数据在 themes 字段中
                    });
                    const matchedProject = this.pendingProjectSync
                        ? this.ensureProjectPair(this.pendingProjectSync)
                        : this.ensureProjectPair();
                    if (matchedProject) {
                        this.getThemesByProjectId(matchedProject.id);
                        this.getWorkTypeByProjectId(matchedProject.id);
                    }
                } else {
                    this.$message.error(res.data.msg || '获取项目列表失败');
                }
            }).catch(err => {
                console.error('获取项目列表失败:', err);
                this.$message.error('获取项目列表失败');
            });
        },
        // 获取所有主题列表
        getAllThemes() {
            this.$get('/api/v1/works/castlist').then(res => {
                if (res.data.code === 200) {
                    this.themeList = res.data.data;
                } else {
                    this.$message.error(res.data.msg || '获取主题列表失败');
                }
            }).catch(err => {
                console.error('获取主题列表失败:', err);
                this.$message.error('获取主题列表失败');
            });
        },
        // 根据项目ID获取对应主题
        getThemesByProjectId(pid) {
            console.log('获取主题列表，项目ID:', pid);
            this.$get(`/api/v1/works/casebypid/${pid}`).then(res => {
                if (res.data.code === 200) {
                    this.themeList = res.data.data || [];
                    console.log('获取到的主题列表:', this.themeList);
                    
                    // 编辑模式或恢复状态时，确保选中的主题有效
                    if (this.selectedTypes) {
                        const foundTheme = this.themeList.find(item => item.name === this.selectedTypes);
                        if (!foundTheme) {
                            // 如果在主题列表中找不到完全匹配的项，尝试从第一个主题开始选择
                            if (this.themeList.length > 0) {
                                console.log('主题未匹配，选择第一个可用的主题:', this.themeList[0]);
                                this.selectedTypes = this.themeList[0].name;
                            } else {
                                console.log('主题列表为空，重置选择');
                                this.selectedTypes = '';
                            }
                        } else {
                            console.log('找到匹配的主题:', foundTheme);
                        }
                    } else if (this.themeList.length > 0) {
                        // 如果还没有选择主题，但有主题列表，默认选择第一个
                        console.log('当前无选择的主题，选择第一个可用的主题:', this.themeList[0]);
                        this.selectedTypes = this.themeList[0].name;
                    }
                } else {
                    this.$message.error(res.data.msg || '获取主题列表失败');
                }
            }).catch(err => {
                console.error('获取主题列表失败:', err);
                this.$message.error('获取主题列表失败');
            });
        },
        // 修改 getWorkTypeByProjectId 方法
        getWorkTypeByProjectId(pid) {
            console.log('获取内容形式，项目ID:', pid);
            this.$get(`/api/v1/works/product/${pid}`).then(res => {
                if (res.data.code === 200) {
                    const worksType = res.data.data.worksType;
                    if (worksType) {
                        this.workTypeOptions = this.convertWorkType(worksType);
                        console.log('获取到的内容形式选项:', this.workTypeOptions);
                        
                        // 检查当前选中的内容形式是否在新的选项列表中
                        if (this.selectedOption) {
                            const foundOption = this.workTypeOptions.find(item => item.value === this.selectedOption);
                            if (!foundOption) {
                                console.log('之前选择的内容形式不在新列表中');
                                
                                // 编辑模式或恢复状态下，不自动重置选择
                                const isEditMode = this.isEdit && this.isEdit();
                                const hasRestoredData = localStorage.getItem('specialtyInfoTemp') || localStorage.getItem('specialtyInfoData');
                                
                                if (!isEditMode && !hasRestoredData) {
                                    this.selectedOption = '';
                                }
                            } else {
                                console.log('找到匹配的内容形式:', foundOption);
                            }
                        }
                    } else {
                        this.$message.warning('未找到内容形式数据');
                        this.workTypeOptions = [];
                    }
                } else {
                    this.$message.error(res.data.msg || '获取内容形式失败');
                }
            }).catch(err => {
                console.error('获取内容形式失败:', err);
                this.$message.error('获取内容形式失败');
            });
        },
        // 修改 convertWorkType 方法
        convertWorkType(worksType) {
            const typeMap = {
                '1': '科普文章',
                '2': '科普图画',
                '3': '科普短视频',
                '4': '科普讲座'
            };
            
            // 如果 worksType 是字符串，先转换为数组
            if (typeof worksType === 'string') {
                const types = worksType.split(',').filter(type => type.trim()); // 分割并过滤空值
                return types.map(type => ({
                    value: type.trim(),
                    label: typeMap[type.trim()] || `未知类型(${type.trim()})`
                }));
            } else if (Array.isArray(worksType)) {
                // 如果已经是数组
                return worksType.map(type => ({
                    value: String(type).trim(),
                    label: typeMap[String(type).trim()] || `未知类型(${String(type).trim()})`
                }));
            } else if (worksType !== null && worksType !== undefined) {
                // 如果是其他类型（如数字），转为字符串处理
                return [{
                    value: String(worksType),
                    label: typeMap[String(worksType)] || `未知类型(${String(worksType)})`
                }];
            }
            
            return [];
        },
        getWorkTypeLabel(value) {
            const typeMap = {
                '1': '科普文章',
                '2': '科普图画',
                '3': '科普短视频',
                '4': '科普讲座'
            };
            return typeMap[value] || `未知类型(${value})`;
        },
        ensureProjectPair(preferred = {}) {
            const list = Array.isArray(this.projectCodeList) ? this.projectCodeList : [];
            const targetId = preferred.projectId !== undefined ? preferred.projectId : this.projectId;
            const targetCode = preferred.projectCode !== undefined ? preferred.projectCode : this.selectedThemeId;

            if (!list.length) {
                this.pendingProjectSync = {
                    projectId: targetId,
                    projectCode: targetCode
                };
                return null;
            }

            const matchById = targetId
                ? list.find(item => String(item.id) === String(targetId))
                : null;
            const matchedProject = matchById || (targetCode
                ? list.find(item => item.xmCode === targetCode)
                : null);

            if (matchedProject) {
                this.projectId = matchedProject.id;
                this.selectedThemeId = matchedProject.xmCode;
                this.pendingProjectSync = null;
                this.updateCachedProjectSelection();
                return matchedProject;
            }

            console.warn('未在项目列表中找到匹配的项目编号/ID，保持当前选择', targetId, targetCode);
            return null;
        },
        updateCachedProjectSelection() {
            const updateStorage = (key) => {
                const raw = localStorage.getItem(key);
                if (!raw) return;
                try {
                    const parsed = JSON.parse(raw);
                    parsed.selectedThemeId = this.selectedThemeId;
                    parsed.projectCode = this.selectedThemeId;
                    parsed.projectId = this.projectId;
                    localStorage.setItem(key, JSON.stringify(parsed));
                } catch (error) {
                    console.error(`更新 ${key} 中的项目缓存失败:`, error);
                }
            };

            updateStorage('specialtyInfoTemp');
            updateStorage('specialtyInfoData');
        },
        // 添加获取文件图标的方法
        getFileIcon(file) {
            if (!file || !file.url) return '';
            
            const fileUrl = file.url.toLowerCase();
            if (fileUrl.endsWith('.mp4')) {
                return require('../../assets/applyRey/mp4.jpg');
            } else if (fileUrl.endsWith('.mov')) {
                return require('../../assets/applyRey/mov.jpg');
            } else if (fileUrl.endsWith('.doc') || fileUrl.endsWith('.docx')) {
                return require('../../assets/applyRey/word.png');
            } else if (fileUrl.endsWith('.pdf')) {
                return require('../../assets/applyRey/pdf.png');
            } else if (fileUrl.match(/\.(jpg|jpeg|png|gif)$/)) {
                return file.url; // 如果是图片文件，直接返回原图片URL
            }
            
            // 默认返回一个通用图标
            return require('../../assets/applyRey/pdf.png');
        },
        // 添加新方法用于保存当前数据
        saveCurrentData() {
            // 构建当前页面数据
            const formData = {
                selectedThemeId: this.selectedThemeId, // 保存项目编号
                projectId: this.projectId,             // 保存项目ID
                projectCode: this.selectedThemeId,     // 兼容性字段
                projectCase: this.selectedTypes,       // 保存主题
                worksType: this.selectedOption,        // 保存内容形式
                worksName: this.name,                  // 保存作品名称
                workTime: this.selected,               // 保存创作时间
                des: this.des,                         // 保存备注信息
                selectedTypes: this.selectedTypes      // 另一个兼容性字段
            };
            
            // 添加所有类型的文件信息 - 使用完整URL
            if (this.uploadedFiles['1']) {
                formData.workFile = this.uploadedFiles['1'].url || '';
                // 确保使用https协议
                if (formData.workFile && formData.workFile.startsWith('http:')) {
                    formData.workFile = formData.workFile.replace('http:', 'https:');
                }
            }
            if (this.uploadedFiles['2']) {
                formData.workPicFile = this.uploadedFiles['2'].url || '';
                // 确保使用https协议
                if (formData.workPicFile && formData.workPicFile.startsWith('http:')) {
                    formData.workPicFile = formData.workPicFile.replace('http:', 'https:');
                }
            }
            if (this.uploadedFiles['3']) {
                formData.workVedioFile = this.uploadedFiles['3'].url || '';
                // 确保使用https协议
                if (formData.workVedioFile && formData.workVedioFile.startsWith('http:')) {
                    formData.workVedioFile = formData.workVedioFile.replace('http:', 'https:');
                }
            }
            if (this.uploadedFiles['4']) {
                formData.workJzFile = this.uploadedFiles['4'].url || '';
                // 确保使用https协议
                if (formData.workJzFile && formData.workJzFile.startsWith('http:')) {
                    formData.workJzFile = formData.workJzFile.replace('http:', 'https:');
                }
            }
            
            // 保存到临时存储和正式存储，确保数据不会丢失
            localStorage.setItem('specialtyInfoTemp', JSON.stringify(formData));
            localStorage.setItem('specialtyInfoData', JSON.stringify(formData));
            console.log('保存当前数据以防丢失 (使用完整URL):', formData);
        },
        // 添加页面可见性变化处理方法
        handleVisibilityChange() {
            if (document.visibilityState === 'visible') {
                console.log('页面重新可见，恢复数据');
                // 尝试恢复数据
                this.restoreDataFromStorage();
            } else {
                console.log('页面隐藏，保存当前数据');
                // 保存当前数据
                this.saveCurrentData();
            }
        },
        // 添加返回按钮处理方法
        handlePopState(event) {
            // 阻止默认返回行为
            history.pushState(null, null, document.URL);
            
            // 保存当前数据
            this.saveCurrentData();
            console.log('检测到返回操作，保存当前数据');
            
            // 询问用户是否要返回
            this.$confirm('确定要返回上一页吗？您的数据已保存', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 用户确认返回，调用上一步方法
                this.ToggleStep('prve');
            }).catch(() => {
                // 用户取消返回
                console.log('用户取消返回');
            });
        },
        // 添加数据恢复方法
        restoreDataFromStorage() {
            try {
                const savedData = localStorage.getItem('specialtyInfoTemp') || localStorage.getItem('specialtyInfoData');
                if (savedData) {
                    const parsedData = JSON.parse(savedData);
                    console.log('从缓存恢复数据:', parsedData);
                    
                    // 恢复基本字段
                    if (parsedData.selectedThemeId) this.selectedThemeId = parsedData.selectedThemeId;
                    if (parsedData.projectId) this.projectId = parsedData.projectId;
                    if (parsedData.selectedTypes || parsedData.projectCase) {
                        this.selectedTypes = parsedData.selectedTypes || parsedData.projectCase;
                    }
                    if (parsedData.worksName) this.name = parsedData.worksName;
                    if (parsedData.workTime) this.selected = parsedData.workTime;
                    if (parsedData.worksType) this.selectedOption = parsedData.worksType;
                    if (parsedData.des) this.des = parsedData.des;
                    
                    // 恢复上传的文件
                    if (parsedData.workFile) {
                        this.$set(this.uploadedFiles, '1', {
                            url: parsedData.workFile,
                            name: '科普文章',
                            status: 'success'
                        });
                    }
                    if (parsedData.workPicFile) {
                        this.$set(this.uploadedFiles, '2', {
                            url: parsedData.workPicFile,
                            name: '科普图画',
                            status: 'success'
                        });
                    }
                    if (parsedData.workVedioFile) {
                        this.$set(this.uploadedFiles, '3', {
                            url: parsedData.workVedioFile,
                            name: '科普短视频',
                            status: 'success'
                        });
                    }
                    if (parsedData.workJzFile) {
                        this.$set(this.uploadedFiles, '4', {
                            url: parsedData.workJzFile,
                            name: '科普讲座',
                            status: 'success'
                        });
                    }
                    
                    // 确保主题和内容类型列表已加载
                    if (this.projectId) {
                        this.getThemesByProjectId(this.projectId);
                        this.getWorkTypeByProjectId(this.projectId);
                    }
                }
            } catch (error) {
                console.error('恢复数据失败:', error);
            }
        },
        // 添加删除文件的方法
        removeFile(fileType) {
            this.$confirm('确定要删除该文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 释放本地URL资源
                if (this.uploadedFiles[fileType] && this.uploadedFiles[fileType].previewUrl) {
                    URL.revokeObjectURL(this.uploadedFiles[fileType].previewUrl);
                }
                
                // 删除文件记录
                this.$delete(this.uploadedFiles, fileType);
                
                // 保存当前状态
                this.saveCurrentData();
                
                this.$message.success('文件已删除');
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        getContentType(filename) {
            // 获取文件扩展名
            const ext = filename.split('.').pop().toLowerCase();
            
            // 根据扩展名返回对应的MIME类型
            const mimeTypes = {
                'jpg': 'image/jpeg',
                'jpeg': 'image/jpeg',
                'png': 'image/png',
                'gif': 'image/gif',
                'pdf': 'application/pdf',
                'doc': 'application/msword',
                'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'xls': 'application/vnd.ms-excel',
                'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'ppt': 'application/vnd.ms-powerpoint',
                'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'txt': 'text/plain',
                'mp4': 'video/mp4',
                'mov': 'video/quicktime',
                'mp3': 'audio/mpeg',
                'wav': 'audio/wav'
            };
            
            return mimeTypes[ext] || '';
        },
        // 添加生成签名URL的方法
        // 为已上传的文件生成带签名的预览URL
        getSignedPreviewUrl(type) {
            if (!this.uploadedFiles[type] || !this.uploadedFiles[type].url) {
                return '';
            }
            
            // 如果URL已经包含签名，直接返回
            if (this.uploadedFiles[type].url.includes('Signature=')) {
                // 确保使用https协议
                let url = this.uploadedFiles[type].url;
                if (url && url.startsWith('http:')) {
                    url = url.replace('http:', 'https:');
                }
                return url;
            }
            
            try {
                // 这里仅模拟获取签名URL的过程，实际项目中可能需要调用API获取
                const config = {
                    region: 'oss-cn-beijing',  // OSS区域
                    bucket: 'bxxcxoss-bahim'   // OSS存储桶名称
                };
                
                // 从当前URL中提取文件路径
                const currentUrl = this.uploadedFiles[type].url;
                let fileKey = '';
                
                // 简单解析URL以获取文件路径
                if (currentUrl) {
                    // 移除协议和域名部分
                    const urlParts = currentUrl.split('/');
                    // 移除前三部分 (protocol, empty, domain)
                    urlParts.splice(0, 3);
                    fileKey = urlParts.join('/');
                }
                
                if (!fileKey) {
                    console.error('无法从URL中提取文件路径:', currentUrl);
                    return currentUrl;
                }
                
                // 实际项目中，这里应该调用API获取签名URL
                // 模拟生成的签名URL (仅作示例)
                // 在实际项目中，应当使用服务端API生成
                let signedUrl = currentUrl;
                
                // 为URL添加查询参数以模拟签名
                // 注意：这只是一个示例，实际的签名需要根据OSS规范生成
                if (signedUrl.includes('?')) {
                    signedUrl += '&Signature=example_signature&Expires=' + Math.floor(Date.now() / 1000 + 3600);
                } else {
                    signedUrl += '?Signature=example_signature&Expires=' + Math.floor(Date.now() / 1000 + 3600);
                }
                
                // 确保使用https协议
                if (signedUrl && signedUrl.startsWith('http:')) {
                    signedUrl = signedUrl.replace('http:', 'https:');
                }
                
                return signedUrl;
            } catch (error) {
                console.error('生成签名URL时出错:', error);
                let url = this.uploadedFiles[type].url;
                // 确保使用https协议
                if (url && url.startsWith('http:')) {
                    url = url.replace('http:', 'https:');
                }
                return url;
            }
        },
        // 提取URL中的路径部分，避免保存完整URL导致数据库字段长度溢出
        extractPathFromUrl(url) {
            if (!url) return '';
            
            // 如果不是http开头的URL，可能只是路径，直接返回
            if (!url.startsWith('http')) return url;
            
            try {
                // 尝试解析URL并获取pathname
                const urlObj = new URL(url);
                // 如果是OSS URL，提取object name
                if (urlObj.hostname.includes('aliyuncs.com')) {
                    // 移除域名和查询参数，只保留路径
                    return urlObj.pathname;
                }
                
                // 对于其他URL，提取pathname部分（不含域名和查询参数）
                return urlObj.pathname;
            } catch (e) {
                console.error('URL解析失败:', e);
                // 如果URL解析失败，尝试使用正则表达式提取
                const match = url.match(/https?:\/\/[^\/]+(\/[^?#]*)/);
                return match ? match[1] : url;
            }
        },
        // 为文件生成带签名的URL
        getSignedFileUrl(type) {
            // 确保有上传文件且文件有URL
            if (!this.uploadedFiles[type] || !this.uploadedFiles[type].url) {
                return '';
            }
            
            try {
                // 不再生成签名URL，直接返回原始URL
                console.log('使用原始URL，不生成签名:', this.uploadedFiles[type].url);
                return this.uploadedFiles[type].url;
            } catch (error) {
                console.error('获取URL失败:', error);
                return this.uploadedFiles[type].url;
            }
        },
    },
    watch: {
        TypeId: function (val) {
            this.ConfigDisabled = this.PageDisabled;
            this.user_group_id = "";
            this.FormData = [];
            if (val == 1) { 
                this.SeleId = ""; 
                this.user_group_id = ""; 
            } else { 
                this.user_group_id = []; 
            }
            this.SeleData = [];
        },
        selectedThemeId: function (newVal) {
            // 监听主题编号变化，动态更新注册类型
            if (newVal) {
                this.ShowData(newVal); // 根据选中的主题编号加载数据
            } else {
                this.selectedTypes = ''; // 清空注册类型选择
                this.SeleData = []; // 清空 SeleData
            }
        },
        worksInfo: {
            immediate: true,
            handler(newVal) {
                if (this.isEdit && this.isEdit()) {
                    const info = this.worksInfo();
                    if (info) {
                        console.log('专业信息数据更新:', info);
                        // 可以在这里添加额外的数据更新逻辑
                    }
                }
            }
        },
        // 添加新的 watch 来监听 $route 变化
        '$route.query': {
            immediate: true,
            handler(query) {
                // 检测是否是从基本信息页跳转过来的
                if (query.type && query.fromPrevious === 'true') {
                    console.log('从基本信息页跳转过来，确保数据已正确加载');
                    
                    // 检查是否为草稿模式
                    const isDraft = localStorage.getItem('isDraft') === 'true';
                    
                    // 获取缓存数据
                    const specialtyInfoData = localStorage.getItem('specialtyInfoData');
                    
                    if (specialtyInfoData) {
                        try {
                            const data = JSON.parse(specialtyInfoData);
                            
                            // 如果有缓存的项目ID和选中的主题，确保它们被加载
                            const themeId = data.selectedThemeId || data.projectCode;
                            const syncProject = () => {
                                const matched = this.ensureProjectPair({
                                    projectId: data.projectId,
                                    projectCode: themeId
                                });
                                if (matched) {
                                    this.getThemesByProjectId(matched.id);
                                    this.getWorkTypeByProjectId(matched.id);
                                }
                            };

                            if (this.projectCodeList.length > 0) {
                                syncProject();
                            } else {
                                setTimeout(syncProject, 300);
                            }
                        } catch (error) {
                            console.error('解析缓存数据出错:', error);
                        }
                    }
                }
            }
        }
    },
    GoToRegister() {
        this.TiShiBlon = false;
        window.location.href = "https://www.camh.org.cn/";
    }
}
</script>

<style scoped>
.TBox{
    height: 40px;
}
.StepJiBenRadio {
    width: 100%;
    margin-bottom: 10px;
}

.StepJiBenRadio :deep(.el-radio-group) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.StepJiBenRadio :deep(.el-radio) {
    width: 20%;
    margin-right: 0;
    margin-bottom: 15px;
    padding-right: 15px;
    box-sizing: border-box;
}

.StepJiBenRadio :deep(.el-radio__label) {
    font-size: 14px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 修改单选按钮颜色 */
:deep(.el-radio__input.is-checked .el-radio__inner) {
    background-color: #58C1B6 !important;
    border-color: #58C1B6 !important;
}

:deep(.el-radio__input.is-checked + .el-radio__label) {
    color: #58C1B6 !important;
}

:deep(.el-radio__inner:hover) {
    border-color: #58C1B6 !important;
}

/* 确保内容形式的单选按钮也使用相同颜色 */
.content-type-radio-group :deep(.el-radio__input.is-checked .el-radio__inner) {
    background-color: #58C1B6 !important;
    border-color: #58C1B6 !important;
}

.content-type-radio-group :deep(.el-radio__input.is-checked + .el-radio__label) {
    color: #58C1B6 !important;
}

.content-type-radio-group :deep(.el-radio__inner:hover) {
    border-color: #58C1B6 !important;
}

.uploaded-thumbnails {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.thumbnail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-direction: row; 
    justify-content: space-between;
    width: 100%;
}

.thumbnail-img {
    width: 50px;
    height: 50px;
    border: 1px solid #ddd;
    cursor: pointer;
    object-fit: contain;
    margin-right: 10px;
    order: -1;
}

.file-name {
    font-size: 14px;
    color: #666;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-actions {
    display: flex;
    gap: 10px;
}

.file-actions :deep(.el-button--text) {
    color: #58C1B6 !important;
    padding: 0;
    font-size: 12px;
}

.file-actions :deep(.el-button--text:hover) {
    color: #4BA89E !important;
}

.file-actions :deep(.el-button--text:active) {
    color: #3E8F86 !important;
}

.uploaded-preview {
    margin: 10px 0;
    padding: 10px;
    background: #f8f8f8;
    border-radius: 4px;
    width: 100%;
}

.requirement-text {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    white-space: pre-wrap; /* 保留换行和空格 */
    word-break: break-word; /* 自动换行 */
}

.no-requirement {
    font-size: 14px;
    color: #999;
}


.StepCommIptVal {
    flex: 1; /* 让容器占据剩余空间 */
    margin: 0 10px;
    min-width: 0; /* 防止溢出 */
}

/* 修改单选组的样式，确保横向排列 */
.StepCommIptVal .el-radio-group {
    display: flex;
    flex-direction: row; /* 明确指定横向排列 */
    flex-wrap: nowrap; /* 防止换行，如果需要换行可用 wrap */
    gap: 20px; /* 选项间距 */
    align-items: center;
}

/* 单选按钮样式 */
.content-radio {
    margin-right: 0; /* 移除默认右边距 */
    white-space: nowrap; /* 防止文本换行 */
}

.content-radio .el-radio__label {
    font-size: 16px;
    color: #666;
    padding-left: 8px; /* 与其他复选框保持一致 */
}

.content-radio .el-radio__input.is-checked .el-radio__inner {
    background-color: #58C1B6;
    border-color: #58C1B6;
}

.content-radio .el-radio__inner {
    border: 1px solid #DCDFE6;
    width: 16px;
    height: 16px;
}

.content-radio .el-radio__inner::after {
    width: 6px;
    height: 6px;
    background: #FFF;
}

.el-checkbox__inner {
    border: 1px solid #DCDFE6;
    width: 16px;
    height: 16px;
}

.el-checkbox__inner::after {
    width: 6px;
    height: 6px;
    background: #FFF;
}

.MarTop {
    margin-top: 20px;
}
.MarLe {
    margin-left: 10px;
}
.MarTop40 {
    margin-top: 40px;
}
.Wid120 {
    width: 230px;
    margin: 0 20px;
}
.Steps {
    display: none;
    align-items: center;
    margin: 30px 0;
    display: none;
}
.StepsItem {
    flex: 1;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #F5F5F5;
    position: relative;
    font-weight: 400;
    font-size: 18px;
    color: #999;
}
.StepJiBen {
    width: 80%;
}
.StepJiBen1 {
    margin: 20px auto;
    width: 40%;
}
.StepJiBenItem {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
.StepJiBenItemTit {
    width: 200px;
    text-align: right;
    margin-right: 20px;
}
.StepJiBenItemTit1 {
    width: 100px;
    text-align: right;
    margin-right: 20px;
}
 .Icon {
    color: #ff0000;
    font-weight: 400;
    font-size: 20px;
    margin-right: 5px;
}
.StepJiBenItemTit .Tit {
    font-weight: 400;
    font-size: 16px;
    color: #666;
}
.StepJiBenItemVal {
    flex: 1;
}
.StepJiBenItemVal .WidMax {
    width: 100%;
}
.StepJiBenItemVal.DisFlex {
    display: flex;
}
.StepHeadTit {
    padding: 10px 20px;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    background: #f5f5f5;
    margin-bottom: 50px;
}
.StepCommItem {
    display: flex;
    align-items: baseline;
}
.StepCommNum {
    font-weight: 400;
    font-size: 20px;
    color: #000000;
}
.StepCommHead {
    margin-left: 20px;
    flex: 1;
}
.StepCommFile {
    font-weight: 400;
    font-size: 16px;
    color: #666;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.StepCommFileTxt {
    display: flex;
    align-items: center;
}
.StepCommFileBtn {
    font-size: 16px;
    padding: 3px 35px;
    background: #58C1B6;
    border-radius: 5px;
    border: 1px solid #58C1B6;
    text-align: center;
    cursor: pointer;
    color: #fff;
}
.StepCommFileMsg {
    font-weight: 400;
    font-size: 16px;
    color: #999999;
}
.StepCommFileLock {
    font-size: 16px;
    color: #58C1B6;
    padding: 0 10px;
}
.StepCommFileLock {
    color: #58C1B6 !important;
}
.StepCommFileLock:hover {
    color: #4BA89E !important;
}
.StepCommFileImg {
    border: 1px solid #ddd;
    padding: 2px;
    cursor: pointer;
    position: relative;
}
.StepCommFileImg img {
    width: 50px;
    height: 50px;
}
.StepCommFileImg .iconfont {
    position: absolute;
    top: -5px;
    right: -7px;
    font-size: 16px;
    color: #d51938;
    cursor: pointer;
    z-index: 9;
}
.StepCommIpt {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}
.StepCommIptMsg {
    margin-left: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #58C1B6;
}
.StepCommIpts {
    display: flex;
    align-items: baseline;
}
.StepCommIptsDis {
    display: flex;
    align-items: baseline;
}
.StepCommIptsTit {
    font-weight: 400;
    font-size: 20px;
    color: #000000;
    margin-right: 20px;
}
.StepCommIptsHref {
    width: 65%;
}
.StepCommIptsHrefDis {
    flex: 1;
    margin-right: 40px;
}
.StepCommIptsHrefMsg {
    margin-top: 10px;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #58C1B6;
}
.StepCommIptsPass {
    flex: 1;
}
.StepBtns {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0
}
.StepBtn {
    margin-right: 20px;
    width: 120px;
    text-align: center;
    padding: 7px 15px;
    color: #fff;
    font-size: 18px;
    background: #58C1B6;
    border-radius: 20px;
    cursor: pointer;
}
.StepBtn.StpepDisabled {
    background: #a8d3cf;
    cursor: no-drop;
}
.SupervisorHead {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.SupervisorItem {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}
.TitleBox {
    width: 100%;
    height: 40px;
    background-color: #F5F5F5;
    line-height: 42px;
    margin-top: 10px;
    text-align: center;
    font-size: 18px;
}
.RoundBox {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #000000;
    margin: 0 10px 0 25px;
}
.StepFontWeight {
    font-weight: 600;
}

/* 添加移动端优化样式 */
@media only screen and (max-width: 768px) {
    .Steps {
        display: flex;
    }
    .StepHeadTit {
        margin-bottom: 15px;
        font-size: 14px;
    }
    .StepCommFileDis {
        display: block;
    }
    .StepCommFileTxt {
        flex-wrap: wrap;
        font-size: 16px;
        margin-top: 10px;
    }
    .StepCommItem {
        margin-top: 20px;
        flex-direction: column;
    }
    .StepCommHead {
        margin-left: 0;
        width: 100%;
    }
    .StepCommFile,
    .StepCommIpt {
        font-size: 16px;
        flex-wrap: wrap;
    }
    
    /* 修复主题选择重叠问题 */
    .StepJiBenRadio .el-radio-group {
        flex-direction: column;
    }
    
    .StepJiBenRadio .el-radio {
        width: 100%;
        margin-bottom: 10px;
        padding-right: 0;
    }
    
    .StepJiBenRadio .el-radio__label {
        white-space: normal;
        line-height: 1.4;
    }
    
    /* 调整项目编号下拉菜单在移动端的宽度 */
    .Wid120 {
        width: 100%;
        margin: 0;
    }
    
    /* 调整内容形式选择样式 */
    .content-form-section {
        margin-top: 15px;
    }
    
    .content-type-radio-group {
        display: flex;
        flex-direction: column;
    }
    
    .content-type-radio {
        margin-bottom: 10px !important;
    }
    
    .content-type-item {
        padding: 10px;
    }
    
    .content-type-header {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .upload-btn {
        margin: 10px 0 0 0;
    }
    
    /* 调整按钮样式 */
    .StepBtn {
        width: 100px;
        font-size: 16px;
        padding: 7px 10px;
    }
    
    /* 优化表单项垂直间距 */
    .MarTop {
        margin-top: 15px;
    }
    
    /* 优化下拉选择器的显示 */
    .SupervisorItem {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .SupervisorItem > div:first-child {
        margin-bottom: 8px;
    }
    
    /* 步骤按钮样式优化 */
    .StepBtns {
        margin: 20px 0;
    }
}

.upload-progress-container {
    margin: 15px 0;
    padding: 15px;
    background-color: #f8f8f8;
    border-radius: 4px;
}

.upload-file-info {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.upload-file-info i {
    font-size: 18px;
    margin-right: 8px;
    color: #409EFF;
}

.upload-file-info span {
    font-size: 14px;
    color: #606266;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 优化移动端显示 */
@media only screen and (max-width: 768px) {
    .upload-progress-container {
        padding: 10px;
    }
    
    .upload-file-info span {
        max-width: 200px;
    }
}

.shuoming {
    color: red;
}
</style>
<style>
.StepJiBenBox .el-card__header {
    padding: 7px 0;
}
.StepJiBenBox .StepJiBenItemTit1 {
    text-align: left !important;
    margin-left: 20px;
}
.StepJiBenItem .el-checkbox__label {
    font-size: 16px !important;
}
/* 添加多选框样式 */
.content-checkbox {
    margin-right: 20px;
    margin-bottom: 10px;
}

.content-checkbox .el-checkbox__label {
    font-size: 16px;
    color: #666;
}

.content-checkbox.is-disabled .el-checkbox__label {
    color: #666 !important; /* 即使禁用也保持正常颜色 */
}

.content-checkbox.is-disabled .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #0385EB !important; /* 选中且禁用时的背景色 */
    border-color: #0385EB !important;
}

/* 添加上传要求的样式 */
.requirement-item {
    margin-bottom: 20px;
}

.requirement-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    color: #0385EB;
}

.requirement-text {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
    padding-left: 10px;
    border-left: 3px solid #58C1B6;
    margin-bottom: 15px;
}
/* 添加新的样式 */
.upload-section {
    margin-bottom: 20px;
    width: 100%;
}

.upload-title {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
}

.uploaded-thumbnails {
    margin-top: 10px;
}

/* 添加新的样式 */
.content-types-container {
    width: 100%;
    margin-top: 20px;
}

.content-type-item {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 20px;
    background: #fff;
}

.content-type-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
}

.content-type-label {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-right: 10px;
}

.upload-btn {
    margin-left: 10px;
}

.uploaded-preview {
    margin: 10px 0;
    padding: 10px;
    background: #f8f8f8;
    border-radius: 4px;
}

.requirement-container {
    margin-top: 10px;
    padding: 10px;
    background: #f8f8f8;
    border-radius: 4px;
}

.requirement-text {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
    padding-left: 10px;
    border-left: 3px solid #58C1B6;
}

/* 修改原有样式 */
.StepCommIptVal {
    width: 100%;
    margin: 0;
}

.thumbnail-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.thumbnail-img {
    width: 50px;
    height: 50px;
    border: 1px solid #ddd;
    cursor: pointer;
}

.file-name {
    font-size: 14px;
    color: #666;
}

/* 添加新的样式 */
.content-form-section {
    display: block !important; 
}

.content-types-container {
    width: 100%;
    margin-top: 20px; /* 增加与"内容形式"的间距 */
}

.content-type-item {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 20px;
    background: #fff;
}

/* 修改上传按钮颜色 */
:deep(.el-button--primary) {
    background-color: #58C1B6 !important;
    border-color: #58C1B6 !important;
}

:deep(.el-button--primary:hover),
:deep(.el-button--primary:focus) {
    background-color: #4BA89E !important;
    border-color: #4BA89E !important;
}

:deep(.el-button--primary:active) {
    background-color: #3E8F86 !important;
    border-color: #3E8F86 !important;
}

/* 添加更具体的上传按钮样式 */
:deep(.el-upload .el-button--primary) {
    background-color: #58C1B6 !important;
    border-color: #58C1B6 !important;
    color: #fff !important;
}

:deep(.el-upload .el-button--primary:hover),
:deep(.el-upload .el-button--primary:focus) {
    background-color: #4BA89E !important;
    border-color: #4BA89E !important;
}

:deep(.el-upload .el-button--primary:active) {
    background-color: #3E8F86 !important;
    border-color: #3E8F86 !important;
}

/* 确保上传按钮样式 */
.upload-btn {
    background-color: #58C1B6 !important;
    border-color: #58C1B6 !important;
    color: #fff !important;
}

.upload-btn:hover,
.upload-btn:focus {
    background-color: #4BA89E !important;
    border-color: #4BA89E !important;
}

.upload-btn:active {
    background-color: #3E8F86 !important;
    border-color: #3E8F86 !important;
}

/* 其他样式保持不变 */
</style>



